import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Box } from 'rebass';
import { Card, Button, Divider, Icon, Image, Label, Message } from 'semantic-ui-react';
import { Form, Input } from 'formsy-semantic-ui-react';

import { Text } from 'Components/Base';
import { errorLabel } from 'Util/form';

import { resolveErrorCode } from '../LoginForm/errorCodeUtil';

const FORM_STATE = {
  INIT: 'INIT',
  DONE: 'DONE',
};

const StyledCard = styled(Card)`
  &.ui.card {
    border-radius: 0;
    width: 100%;
    min-width: 320px;
  }
  &.ui.card > .content {
    ${'' /* align-items: center; */};
  }
`;

const FWButton = styled(Button)`
  width: 100%;
`;

const SImage = styled(Image)`
  &&&& {
    display: block;
    max-width: 210px;
    margin: 16px auto 8px;
  }
`;

const IconBot = styled(props => <i {...props} className={`tcst-tcasbot ${props.className}`} />)`
  font-size: 140%;
  vertical-align: sub;
  margin-right: 4px;
  line-height: 14px !important;
`;

const FormBox = styled(Box)`
  max-width: 300px;
`;

class ForgotPasswordForm extends Component {
  static propTypes = {
    logoUrl: PropTypes.string,
    formState: PropTypes.string,
    success: PropTypes.string,
    error: PropTypes.object,
    loading: PropTypes.bool,
    onForgotPasswordClick: PropTypes.func,
    onGoToPreviousPageClick: PropTypes.func,
  };

  static defaultProps = {
    logoUrl: '/images/tcaster_logo.png',
    onForgotPasswordClick: () => {},
    onGoToPreviousPageClick: () => {},
  };

  onForgotPasswordClick = form => {
    const { email } = form;
    this.props.onForgotPasswordClick(email);
  };

  onGoToPreviousPageClick = () => {
    this.props.onGoToPreviousPageClick();
  };

  renderForm() {
    const { loading } = this.props;
    return (
      <Form onValidSubmit={this.onForgotPasswordClick}>
        <Form.Field>
          <Text is="label" fontWeight={400} style={{ fontWeight: 400 }}>
            อีเมล
          </Text>
          <Input
            name="email"
            required
            validations="isEmail"
            validationErrors={{
              isEmail: 'อีเมลต้องอยู่ในรูปแบบของ username@domain.com',
              isDefaultRequiredValue: 'กรุณาใส่อีเมล',
            }}
            placeholder=""
            errorLabel={errorLabel}
          />
        </Form.Field>

        <FWButton
          primary
          circular
          size="medium"
          type="submit"
          content={
            <span style={{ fontWeight: 400 }}>
              <IconBot />
              รีเซ็ตรหัสผ่าน
            </span>
          }
          loading={loading}
          disabled={loading}
        />
      </Form>
    );
  }

  render() {
    const { logoUrl, formState, success, error } = this.props;

    return (
      <StyledCard>
        <Card.Content>
          <SImage src={logoUrl} centered />
          <Box mb={2} />
          {formState === FORM_STATE.INIT ? (
            <FormBox pb={3} mx="auto" pt={3}>
              <Box mb={1}>
                <Text fontWeight={500} textAlign="center" mb={3}>
                  รีเซ็ตรหัสผ่าน
                </Text>
                <Text mb={3} fontSize={14}>
                  กรุณากรอกอีเมลที่ใช้สมัคร
                </Text>
              </Box>
              {this.renderForm()}
            </FormBox>
          ) : (
            <Fragment>
              {error ? (
                <Message negative>{resolveErrorCode(error.code)}</Message>
              ) : (
                <Message success>{success}</Message>
              )}
              <FWButton
                primary
                circular
                size="medium"
                content={
                  <span style={{ fontWeight: 400 }}>
                    <IconBot />
                    ย้อนกลับ
                  </span>
                }
                onClick={this.onGoToPreviousPageClick}
              />
            </Fragment>
          )}
        </Card.Content>
      </StyledCard>
    );
  }
}

ForgotPasswordForm.FORM_STATE = FORM_STATE;

export default ForgotPasswordForm;
